import React from 'react'
import './Map.css'
function Map() {
  return (
    <div className='map'><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.60141226691!2d87.16282001448478!3d25.21666093709988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f041ba9ab5e6e1%3A0x303b5e55af2af637!2sSB%20paThsala!5e0!3m2!1sen!2sin!4v1680279029347!5m2!1sen!2sin" width="100%" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">Map OF sbpathshala Coaching Center</iframe> </div>
  )
}

export default Map